import { IModelResponse } from '@cian/http-api';

import {
  IPrebookOfferResponse200,
  IPrebookOfferResponse,
} from '../../../repositories/profitbase-booking/v1/prebook-offer';
import { ResponseError } from '../../../utils/errors';

interface IPrebookOfferRequiredResponse extends IPrebookOfferResponse {
  profitbaseLkUrl: string;
}

interface IPrebookOfferRequiredResponse200 extends IModelResponse<IPrebookOfferRequiredResponse> {
  statusCode: 200;
}

export function assertResponseBody(
  response: IPrebookOfferResponse200,
): asserts response is IPrebookOfferRequiredResponse200 {
  if (!response.response.profitbaseLkUrl) {
    const { errors } = response.response;

    throw new ResponseError({
      domain: 'NewbuildingCard.services.fetchProfitbaseBooking',
      message: 'FetchPrebookOffer returned empty Profitbase link',
      details: { errors: JSON.stringify(errors) },
    });
  }
}
